<div [class]="mainClass + ', rule-item'">
  <div
    [class]="'rule-container' + (requiredRules[rule.humanID] ? ' needed' : '') +
    (invalidRules[rule.humanID] ? ' invalid' : '') +
    (og[rule.humanID] !== edits[rule.humanID] ? ' edited' : '')">
    <div class="text">
      {{ rule.text }}
    </div>
    <div>
      <input
        type="checkbox"
        (change)="check(edits, rule, invalidRules, requiredRules)"
        [(ngModel)]="edits[rule.humanID]">
      @if (rule.rules.length) {
        <button (click)="hideChildren = !hideChildren" type="button">
          <app-display-icon [icon]="hideChildren ? icon.arrowDown : icon.arrowUp"></app-display-icon>
        </button>
      }
    </div>
  </div>
  @if (rule.rules.length) {
    <div [hidden]="hideChildren" class="children">
      @for (child of rule.rules; track $index) {
        <app-rule-form [check]="check" [edits]="edits" [invalidRules]="invalidRules" [og]="og"
                       [requiredRules]="requiredRules" [rule]="child"></app-rule-form>
      }
    </div>
  }
</div>
